export function NotFoundPage(): JSX.Element {
  return (
    <main className="flex h-full min-h-screen flex-col items-center justify-center gap-3 bg-slate-950 px-6 text-center text-slate-200">
      <h2 className="text-2xl font-semibold">Page not found</h2>
      <p className="max-w-md text-sm text-slate-400">
        Open a monitor link of the form
        <br />
        <code className="font-mono text-xs">/e/&lt;eventId&gt;?token=&lt;hex&gt;</code>
      </p>
    </main>
  );
}
